var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PageHeader',{attrs:{"title":"Užklausos veiksmų istorija"}}),_c('DataTable',{attrs:{"table":_vm.table}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }